import React from 'react';

const TransactionHistory = () => {
    return (
        <div className="col-md-5 col-xl-5">
            <div className="card ht-100p">
                <div className="card-header d-flex align-items-center justify-content-between pd-r-10">
                    <h6 className="mg-b-0">Transaction History</h6>
                    <div className="d-flex tx-16">
                        <a href="" className="link-03 lh-0">
                            <ion-icon name="reload-outline"></ion-icon>
                        </a>
                        <a href="" className="link-03 lh-0 mg-l-5">
                            <ion-icon name="ellipsis-vertical"></ion-icon>
                        </a>
                    </div>
                </div>
                {/*<ul className="list-group list-group-flush tx-13">*/}
                {/*    <li className="list-group-item d-flex pd-sm-x-20">*/}
                {/*        <div className="avatar d-none d-sm-block"><span*/}
                {/*            className="avatar-initial rounded-circle bg-teal"><ion-icon name="checkmark"*/}
                {/*                                                                        className="tx-20"></ion-icon></span>*/}
                {/*        </div>*/}
                {/*        <div className="pd-sm-l-10">*/}
                {/*            <p className="tx-medium mg-b-0">Payment from #10322</p>*/}
                {/*            <small className="tx-12 tx-color-03 mg-b-0">Mar 21, 2023, 3:30pm</small>*/}
                {/*        </div>*/}
                {/*        <div className="mg-l-auto text-end">*/}
                {/*            <p className="tx-medium mg-b-0">+ $250.00</p>*/}
                {/*            <small className="tx-12 tx-success mg-b-0">Completed</small>*/}
                {/*        </div>*/}
                {/*    </li>*/}
                {/*    <li className="list-group-item d-flex pd-sm-x-20">*/}
                {/*        <div className="avatar d-none d-sm-block"><span*/}
                {/*            className="avatar-initial rounded-circle bg-indigo op-5"><ion-icon name="return-down-back"*/}
                {/*                                                                               className="tx-20"></ion-icon></span>*/}
                {/*        </div>*/}
                {/*        <div className="pd-sm-l-10">*/}
                {/*            <p className="tx-medium mg-b-2">Process refund to #00910</p>*/}
                {/*            <small className="tx-12 tx-color-03 mg-b-0">Mar 21, 2023, 1:00pm</small>*/}
                {/*        </div>*/}
                {/*        <div className="mg-l-auto text-end">*/}
                {/*            <p className="tx-medium mg-b-2">-$16.50</p>*/}
                {/*            <small className="tx-12 tx-success mg-b-0">Completed</small>*/}
                {/*        </div>*/}
                {/*    </li>*/}
                {/*    <li className="list-group-item d-flex pd-sm-x-20">*/}
                {/*        <div className="avatar d-none d-sm-block"><span*/}
                {/*            className="avatar-initial rounded-circle bg-orange op-5"><ion-icon name="bus-outline"*/}
                {/*                                                                               className="tx-20"></ion-icon></span>*/}
                {/*        </div>*/}
                {/*        <div className="pd-sm-l-10">*/}
                {/*            <p className="tx-medium mg-b-2">Process delivery to #44333</p>*/}
                {/*            <small className="tx-12 tx-color-03 mg-b-0">Mar 20, 2023, 11:40am</small>*/}
                {/*        </div>*/}
                {/*        <div className="mg-l-auto text-end">*/}
                {/*            <p className="tx-medium mg-b-2">3 Items</p>*/}
                {/*            <small className="tx-12 tx-info mg-b-0">For pickup</small>*/}
                {/*        </div>*/}
                {/*    </li>*/}
                {/*    <li className="list-group-item d-flex pd-sm-x-20">*/}
                {/*        <div className="avatar d-none d-sm-block"><span*/}
                {/*            className="avatar-initial rounded-circle bg-teal"><ion-icon name="checkmark-outline"*/}
                {/*                                                                        className="tx-20"></ion-icon></span>*/}
                {/*        </div>*/}
                {/*        <div className="pd-sm-l-10">*/}
                {/*            <p className="tx-medium mg-b-0">Payment from #023328</p>*/}
                {/*            <small className="tx-12 tx-color-03 mg-b-0">Mar 20, 2023, 10:30pm</small>*/}
                {/*        </div>*/}
                {/*        <div className="mg-l-auto text-end">*/}
                {/*            <p className="tx-medium mg-b-0">+ $129.50</p>*/}
                {/*            <small className="tx-12 tx-success mg-b-0">Completed</small>*/}
                {/*        </div>*/}
                {/*    </li>*/}
                {/*    <li className="list-group-item d-flex pd-sm-x-20">*/}
                {/*        <div className="avatar d-none d-sm-block"><span*/}
                {/*            className="avatar-initial rounded-circle bg-gray-400"><ion-icon name="close-outline"*/}
                {/*                                                                            className="tx-20"></ion-icon></span>*/}
                {/*        </div>*/}
                {/*        <div className="pd-sm-l-10">*/}
                {/*            <p className="tx-medium mg-b-0">Payment failed from #087651</p>*/}
                {/*            <small className="tx-12 tx-color-03 mg-b-0">Mar 19, 2023, 12:54pm</small>*/}
                {/*        </div>*/}
                {/*        <div className="mg-l-auto text-end">*/}
                {/*            <p className="tx-medium mg-b-0">$150.00</p>*/}
                {/*            <small className="tx-12 tx-danger mg-b-0">Declined</small>*/}
                {/*        </div>*/}
                {/*    </li>*/}
                {/*</ul>*/}
                <div className="card-footer text-center tx-13">
                    <a href="" className="link-03 d-inline-flex align-items-center">No Transactions <ion-icon
                        name="arrow-down-outline" className="tx-12 mg-b-2"></ion-icon></a>
                </div>
            </div>
        </div>
    );
};

export default TransactionHistory;
